import styled from "styled-components";

import { ICON_HEIGHT } from "./_constants";

const IconChevron = styled.img.attrs({
  src: "/assets/images/icon-chevron-down.svg"
})`
  cursor: pointer;
  height: ${ICON_HEIGHT}px;
`;
IconChevron.displayName = "IconChevron";

export default IconChevron;
